//
//
//
//
//
//
//
//
//

export default {
  name: "license",
};
